import { CarouselWithDefault } from "@/sales-tools/home-product/components/FullOfferChecklist/components/carousels/CarouselWithDefault";

type EngagementCarouselParams = {
    examples: string[];
};
export function EngagementCarousel({ examples }: EngagementCarouselParams) {
    const checklistItemExamples = examples.map((text) => ({ text }));

    return <CarouselWithDefault examples={checklistItemExamples} />;
}
